import React from "react";

import {isMobile} from 'react-device-detect';

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import OrderItem from "./components/OrderItem";
import Order from "./components/Order";
import {calcApiFetch} from "./fetch/fetch";
import {Jumbotron} from "react-bootstrap";
import BASE_URL, {DEFAULT_OPTIONS, ETIKETKI} from "./const";
import {scrollToRefObject} from "./components/price";


const fetchSettings = (onSuccess) => {
    calcApiFetch('/wp-admin/admin-ajax.php?action=get_settings', {method: 'GET'}, (e) => {
        onSuccess({...e, ...{etiketkis: JSON.parse(e.etiketkis)}})
    }, console.log);
};

const fetchEtiketkis = (onSuccess) => {
    //calcApiFetch('/wp-admin/admin-ajax.php?action=get_etiketkis', {method: 'GET'}, onSuccess, console.log);
    onSuccess(ETIKETKI);
};

const App = () => {
    const [options, setOptions] = React.useState(DEFAULT_OPTIONS);
    const [items, setItems] = React.useState([]);
    //const [etiketkis, setEtiketkis] = React.useState([]);
    const [orderId, setOrderId] = React.useState(null);
    const [orderUuid, setOrderUuid] = React.useState(null);
    const orderRef = React.useRef(null);
    const startRef = React.useRef(null);


    React.useEffect(() => {
        fetchSettings(setOptions);
    }, []);

    /*    React.useEffect(() => {
            fetchEtiketkis(setEtiketkis);
        }, []);*/

    const deleteItem = (index) => {
        console.log(index);
        setItems([...items.filter((e, i) => i !== index - 1)]);
    };
    const onOrderSuccess = (id, uuid) => {
        setOrderId(id);
        setOrderUuid(uuid)
        scrollToRefObject(orderRef);
    };

    if (orderId) {
        window.top.location.href = BASE_URL + '/payment-info/?uuid=' + orderUuid;
    }

    return (
        <div ref={startRef} style={{padding: isMobile ? '0' : '40px'}}>
            {!orderId && <OrderItem options={options}
                                    items={items}
                                    etiketkis={options.etiketkis}
                                    onGotoStart={() => scrollToRefObject(startRef)}
                                    onAdd={item => {
                                        setItems([...items, item]);
                                        setTimeout(() => scrollToRefObject(orderRef), 200);
                                    }}/>}
            <div ref={orderRef}></div>
            {!orderId && <Order items={items}
                                deleteItem={deleteItem}
                                onOrderSuccess={onOrderSuccess}
                                options={options}/>}
            {
                orderId
                && <Jumbotron>
                    <h2>Ваш Заказ поступил в обработку. После проверки файла наш специалист свяжется с Вами.</h2>
                    <h4>Номер вашего заказа: {orderId}</h4>
                </Jumbotron>
            }
        </div>
    )
};

export default App;
